<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <title-text>LandBank.</title-text>
      </v-col>
      <v-col cols="12">
        <div class="d-flex overflow-x-auto">
          <v-alert
            @click="selectIndex(i)"
            tile
            dark
            :outlined="selectedIndex != i"
            :color="selectedIndex == i ? 'secondary' : 'primary'"
            class="d-flex mr-2 cursor-pointer"
            :class="{
              'py-2 px-3 text-body-1': $vuetify.breakpoint.smAndDown,
              'py-4 px-8': !$vuetify.breakpoint.mdAndDown,
            }"
            v-for="(option, i) in options"
            :key="i"
          >{{ option }}</v-alert>
        </div>
      </v-col>
      <!-- <v-col cols="12" sm="6" md="4" xl="3" v-for="i in 6" :key="i">
        <offer-card
          @aboutLandbank="aboutDialog = true"
          @buyLandbank="selectPaymentMethodDialog = true"
          v-if="selectedIndex == 0"
        />
      </v-col>-->
    </v-row>
    <offers v-if="selectedIndex == 0" />
    <landbanks @handleNoLandbank="selectIndex(0)" v-if="selectedIndex == 1" />
    <pending @handlePending="selectIndex(0)" v-if="selectedIndex == 2" />
  </v-container>
</template>

<script>
import TitleText from "@/components/dashboard/DbTitleText.vue";
import Pending from "./Pending";
import Offers from "./Offers";
import Landbanks from "./Landbanks";

export default {
  components: {
    TitleText,
    Offers,
    Pending,
    Landbanks,
  },
  data() {
    return {
      selectedIndex: 0,
      aboutDialog: null,
      options: ["Offers", "Active", "Pending"],
      selectPaymentMethodDialog: null,
      amountPaystack: 5004034,
      paystackKey: process.env.VUE_APP_PAYSTACK_KEY,
      paymentOptions: [
        {
          name: "Pay with Paystack",
          description: "For card and bank transfers",
          icon: "paystack-icon",
        },
        {
          name: "Pay with Wallet",
          description: "Directly from your wallet",
          icon: "wallet-icon",
        },
      ],
      numberOfUnits: 1,
      reference: "",
      userObj: {
        email: "gideonpeters85@gmail.com",
      },
    };
  },
  methods: {
    selectIndex(value) {
      this.selectedIndex = value;
    },
    openPaystack() {
      const btn = document.querySelector(".payButton");
      btn.click();
    },
    initiatePayment() {
      this.selectPaymentMethodDialog = null;
      this.openPaystack();
    },
  },
};
</script>
